module.exports = __webpack_public_path__ + "static/media/BariolBold-Italic.99a67412.woff";